import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import TagManager from 'react-gtm-module'
import ReactGA from 'react-ga'
import { Button } from './components/ui/button'
import Regions from './components/Regions'
import Services from './components/Services'

const tagManagerArgs = {
    gtmId: 'GTM-TJP4CNC'
}
const initGA = () => {
    ReactGA.initialize('UA-177328195-1')
    ReactGA.pageview(window.location.pathname + window.location.search)
}

const Main = () => {
    const { t } = useTranslation()

    useEffect(() => {
        initGA()
        TagManager.initialize(tagManagerArgs)
    }, [])

    return (
        <>
            <section className="relative flex items-center justify-center min-h-[70vh] bg-gradient-to-br from-[hsl(220,26%,14%)] to-[hsl(220,22%,20%)]">
                <div className="mx-auto max-w-4xl px-4 text-center">
                    <h1 className="text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl text-white">
                        MV Data
                    </h1>
                    <p className="mt-6 text-lg text-white/70 sm:text-xl max-w-2xl mx-auto">
                        {t('home.headline')}
                    </p>
                    <div className="mt-10">
                        <Link to="/contact">
                            <Button size="lg" className="text-base px-8">
                                {t('home.cta')}
                            </Button>
                        </Link>
                    </div>
                </div>
            </section>
            <Services />
            <Regions />
        </>
    )
}

export default Main
